import { render, staticRenderFns } from "./NewAttribute.vue?vue&type=template&id=aecc36a8"
import script from "./NewAttribute.vue?vue&type=script&lang=js"
export * from "./NewAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports